import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=21c405de&scoped=true&"
import script from "./popup.vue?vue&type=script&lang=js&"
export * from "./popup.vue?vue&type=script&lang=js&"
import style0 from "./popup.vue?vue&type=style&index=0&id=21c405de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c405de",
  null
  
)

export default component.exports